module.exports = __webpack_public_path__ + "static/media/info_email.b0b3e913.svg";